import clsx from 'clsx';
import { FC, useMemo } from 'react';
import { VOLKSWAGEN_DISCOUNT_MAKES } from 'src/constants/constants';
import { BasicModal } from 'src/general/components/BasicModal/BasicModal';
import styles from './VWFSModal.module.scss';

type Props = {
  id?: string;
  onClose: () => void;
  isOpen: boolean;
};

export const VWFSModal: FC<Props> = ({ id, onClose, isOpen }) => {
  /* Get all makes from constants file and split into 2 arrays */
  const makesList = VOLKSWAGEN_DISCOUNT_MAKES;
  const [makesListFirstHalf, makesListSecondHalf] = useMemo(() => {
    const midpoint = Math.ceil(makesList.length / 2);
    return [makesList.slice(0, midpoint), makesList.slice(midpoint)];
  }, [makesList]);

  return (
    <BasicModal
      id={id ?? 'volkswagen-financial-services-details'}
      title="Volkswagen Financial Services"
      onClose={onClose}
      isOpen={isOpen}
    >
      <div className={styles.content}>
        <p className={clsx('c-fs-caption', 'font-normal', styles.text)}>
          Take advantage of a 0.2% discount when buying a Volkswagen Group branded vehicle or a 0.5% discount when
          purchasing a Porsche.
        </p>
        <p className={clsx('c-fs-caption', 'font-normal', styles.text)}>Included makes:</p>
        <div className={clsx('c-fs-caption', 'font-normal', styles.makesList)}>
          <ul className={clsx(styles.makeColumn, styles.text)}>
            {makesListFirstHalf.map((make) => (
              <li key={make} className={styles.makes}>
                {make}
              </li>
            ))}
          </ul>
          <ul className={clsx(styles.makeColumn, styles.text)}>
            {makesListSecondHalf.map((make) => (
              <li key={make} className={styles.makes}>
                {make}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </BasicModal>
  );
};
